import { useContext, useEffect, useState } from 'react';
import { Box, Typography, LinearProgress, Paper } from '@mui/material';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import { clearCookies } from 'src/utils/cookiesHelper';
import { systemId } from 'src/app.config';
import AuthContext from 'src/contexts/authentication/AuthProvider';

const PERMISSIONS_KEY = `metbus_permissions_${systemId}`;
const PERMISSIONS_TOKEN_KEY = `permission_token_${systemId}`;

const SystemAccessDenied = () => {
  const [progress, setProgress] = useState(0);
  const duration = 5000; // 3 segundos
  const intervalTime = 100; // Actualizar cada 100ms para suavidad

  const { logout } = useContext(AuthContext);

  useEffect(() => {
    // Timer para la barra de progreso
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) return 100;
        return prevProgress + 100 / (duration / intervalTime);
      });
    }, intervalTime);

    // Limpieza de sesión y redirección al login
    const logoutTimeout = setTimeout(() => {
      clearCookies();
      sessionStorage.removeItem(PERMISSIONS_KEY);
      sessionStorage.removeItem(PERMISSIONS_TOKEN_KEY);
      logout();
    }, duration);

    return () => {
      clearInterval(timer);
      clearTimeout(logoutTimeout);
    };
  }, []);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="50vh"
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 400,
          textAlign: 'center',
          borderRadius: 2,
          borderTop: '4px solid',
          borderColor: 'secondary.main',
        }}
      >
        <LockPersonIcon
          color="secondary"
          sx={{ fontSize: 60, mb: 2 }}
        />

        <Typography
          variant="h5"
          fontWeight="bold"
          gutterBottom
        >
          Acceso Denegado
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          mb={3}
        >
          No tiene acceso a este sistema.
        </Typography>

        <Box sx={{ width: '100%', mt: 2 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: 'block', mb: 1 }}
          >
            Cerrando sesion...
          </Typography>
          <LinearProgress
            variant="determinate"
            value={progress}
            color="secondary"
            sx={{ height: 8, borderRadius: 5 }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default SystemAccessDenied;
